module.exports = __webpack_public_path__ + "static/media/designer-clip-background.e1dc087c.jpeg";